// Spinner — the busy indicator (DESIGN_LANGUAGE.md §9). The language had NO
// spinner primitive at all; 40 surfaces flashed ad-hoc "Loading…" strings
// instead. Two legal uses only:
//   1. inside a control while its action is in flight (label swaps to this,
//      inside a minWidth floor so the control never resizes — Rule 66)
//   2. a true indeterminate full-surface operation (canvas stage)
// Content-shaped loads use Skeleton, never this.
//
// Ring draws in `line` with a `currentColor` head, so it inherits whatever
// ink its surface carries (correct on both themes and on hued surfaces).
// Sized via the fixed-px icon tokens; `size` prop picks the token.
export const LoadingSpinner = {
  display: 'inline-block',
  boxSize: 'iconMd',
  flexShrink: '0',
  round: '50%',
  borderWidth: 'hairline2',
  borderStyle: 'solid',
  borderColor: 'line',
  borderTopColor: 'currentColor',
  animation: 'rotate 0.8s linear infinite',
  role: 'status',
  // FUNCTION form: it switches on every engine (a template on an attribute
  // needs element ≥ 3.14.788, I18N-CONVENTION §1.1), and the literal read
  // `Loading` to a Georgian screen reader on every busy surface (live walk
  // 2026-09-22).
  'aria-label': (el) => el.call('polyglot', 'common.state.loading')
}
